<template>
	<v-menu v-model="menu" :close-on-content-click="false" offset-y>
		<template v-slot:activator="{ on, attrs }">
			<v-btn v-bind="attrs" v-on="on" plain class="text-lowercase">
				<!-- class="text-capitalize" only if name -->
				<v-icon class="pr-1">mdi-account</v-icon>
				{{ $_.get(currentUser, 'general.username') }}
			</v-btn>
		</template>
		<v-card>
			<v-list>
				<v-list-item>
					<v-list-item-avatar>
						<v-icon large class="pr-1">mdi-account-circle-outline</v-icon>
					</v-list-item-avatar>

					<v-list-item-content>
						<v-list-item-title>{{ $_.get(currentUser, 'general.name') }}</v-list-item-title>
						<v-list-item-subtitle>{{ $_.get(currentUser, 'general.username') }} </v-list-item-subtitle>
						<v-list-item-subtitle>{{ $_.get(currentUser, 'general.email') }} </v-list-item-subtitle>
					</v-list-item-content>

					<v-list-item-action class="mr-4">
						<v-icon v-if="$_.get(currentUser, 'status.passwordUpdatePending')" color="red"
							>mdi-shield-alert-outline</v-icon
						>
						<v-icon v-else color="green">mdi-shield-check-outline</v-icon>
					</v-list-item-action>
				</v-list-item>
			</v-list>
			<v-divider />
			<v-list>
				<v-list-item>
					<v-list-item-icon class="my-4">
						<v-icon class="pl-2 mr-8">mdi-account-lock</v-icon>
					</v-list-item-icon>
					<v-list-item-subtitle>{{ getEffectiveFrontendRoles }}</v-list-item-subtitle>
				</v-list-item>
			</v-list>
			<v-divider />
			<v-list v-if="$_.get(currentUser.references.worker, '_id', false)">
				<v-list-item>
					<v-list-item-icon class="my-4">
						<v-icon class="pl-2 mr-6">mdi-account-hard-hat</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>
							{{ titleName }}
						</v-list-item-title>
						<v-list-item-subtitle>{{ internationalAddress }} </v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
			</v-list>

			<v-card-actions>
				<v-btn @click="logout" outlined small color="primary" text> {{ $t('$global.actions.logout') }}</v-btn>
				<v-spacer></v-spacer>
				<v-btn @click="menu = false" outlined small color="primary" text> {{ $t('$global.actions.close') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-menu>
</template>
<script>
import i18n from './dictionary.js';
import { mapActions } from 'pinia';
import { useAuthStore } from '@/plugins/auth/store';
export default {
	name: 'AppBarUser',
	components: {},
	props: {
		currentUser: {
			type: Object,
			required: true,
		},
	},
	i18n,
	data() {
		return {
			menu: false,
		};
	},
	computed: {
		getEffectiveFrontendRoles() {
			return this.$_.get(this.currentUser, 'effectiveFrontendRoles').sort().join(', ');
		},
		titleName() {
			let personString = '';
			const title = this.$_.get(this.currentUser, 'references.worker.references.person.general.title', '');
			if (title) personString += title + ' ';
			personString +=
				this.$_.get(this.currentUser, 'references.worker.references.person.general.firstname', '') +
				' ' +
				this.$_.get(this.currentUser, 'references.worker.references.person.general.lastname', '');
			return personString;
		},
		internationalAddress() {
			const addressRef = this.$_.get(this.currentUser, 'references.worker.references.person.address');
			let addressStr = this.$_.get(addressRef, 'street') ? this.$_.get(addressRef, 'street') + ', ' : '';
			addressStr += this.$_.get(addressRef, 'zipCode') ? this.$_.get(addressRef, 'zipCode') + '-' : '';
			addressStr += this.$_.get(addressRef, 'city') ? this.$_.get(addressRef, 'city') + ', ' : '';
			addressStr += this.$_.get(addressRef, 'country') ? this.$_.get(addressRef, 'country') : '';
			return addressStr;
		},
	},
	methods: {
		...mapActions(useAuthStore, ['logout']),
	},
};
</script>
